import { observable, makeObservable } from 'mobx';

import { createModelSchema, primitive } from 'serializr';
import { optional } from '@vromo/models';

export const statuses = {
    unfinished: 'Status 1',
    driving: 'Status 2',
    before_deadline: 'Status 3'
};
export class PolicyCapacity {
    maxLoad?: number;
    loadRejection?: boolean;
    notifyUrl?: string;
    statusMode?: keyof typeof statuses;

    jobsGroup?: number;
    vehiclesGroup?: number;

    constructor(init?: Partial<PolicyCapacity>) {
        makeObservable(this, {
            maxLoad: observable,
            loadRejection: observable,
            notifyUrl: observable,
            statusMode: observable,
            jobsGroup: observable,
            vehiclesGroup: observable
        });

        Object.assign(this, init);
    }
}

createModelSchema(PolicyCapacity, {
    maxLoad: optional(primitive()),
    loadRejection: optional(primitive()),
    notifyUrl: optional(primitive()),
    statusMode: optional(primitive()),

    jobsGroup: optional(primitive()),
    vehiclesGroup: optional(primitive())
});
